import styled, { css } from 'styled-components';
import { FlexCenteredColumn, FlexColumn } from '../../styled/common';
import { Typography } from '../ui/Typography';

export const StepsModalTitle = styled(Typography)``;

export const StepsModalContentContainer = styled(FlexColumn)`
  padding: 40px 20px 0;
  gap: 30px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 650px;
    padding: 60px;
    background-color: ${({ theme: { colors } }) => colors.background.primary};
    border-radius: 14px;
    gap: 40px;
  }

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    width: 720px;
  }
`;

const transitionStyles = (transition: string) => css`
  transition: ${transition} 0.3s ease;
`;

const containerStateStyles = (color: string) => css`
  border-color: ${({ theme }) => theme.colors.systemColors.blue};
  ${transitionStyles('border-color')}

  span {
    ${transitionStyles('color')};
    color: ${color};
  }

  svg path {
    ${transitionStyles('fill')};
    fill: ${color};
  }

  &:nth-of-type(4) {
    svg rect,
    svg path {
      ${transitionStyles('stroke')};
      stroke: ${color};
    }
  }
`;

export const StepModalOption = styled(FlexCenteredColumn)`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  padding: 30px 15px;
  gap: 15px;

  @media (hover: hover) {
    &:hover {
      ${({ theme }) => containerStateStyles(theme.colors.systemColors.blue)};
    }
  }
`;

export const StepModalOptionText = styled(Typography)``;
